import React from 'react';
import { Space, Typography } from 'antd';
import { InstagramFilled, FacebookFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Text } = Typography;

const BRAND_INDIGO = '#2E2B81';
const BRAND_INDIGO_DEEP = '#1e1b6e';
const BRAND_GREEN = '#00984A';
const BRAND_YELLOW = '#FFC200';

const SOCIAL_LINKS = [
  //{ href: '#', icon: <LinkedinFilled />, label: 'LinkedIn' },
  { href: 'https://www.instagram.com/pepoll.pesquisas', icon: <InstagramFilled />, label: 'Instagram' },
  { href: 'https://www.facebook.com/pepoll.pesquisas', icon: <FacebookFilled />, label: 'Facebook' },
  //{ href: '#', icon: <TwitterOutlined />, label: 'X (Twitter)' },
  //{ href: '#', icon: <YoutubeOutlined />, label: 'YouTube' },
];

export const PublicFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: `linear-gradient(135deg, ${BRAND_INDIGO} 0%, ${BRAND_INDIGO_DEEP} 100%)`,
        padding: '48px 24px 32px',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        {/* Linha superior: logo + redes sociais */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 24,
          }}
        >
          <img
            src="/assets/brand/logo.png"
            alt="PePoll"
            style={{ height: 28, filter: 'brightness(0) invert(1)' }}
          />

          <Space size={20}>
            {SOCIAL_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                style={{
                  color: 'rgba(255,255,255,0.55)',
                  fontSize: 20,
                  display: 'inline-flex',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(255,255,255,0.55)';
                }}
              >
                {link.icon}
              </a>
            ))}
          </Space>
        </div>

        {/* Barra decorativa verde → amarelo */}
        <div
          style={{
            height: 3,
            background: `linear-gradient(90deg, ${BRAND_GREEN}, ${BRAND_YELLOW})`,
            borderRadius: 2,
            margin: '32px 0',
          }}
        />

        {/* Linha inferior: copyright + Vogals */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 12,
          }}
        >
          <Text style={{ color: 'rgba(255,255,255,0.40)', fontSize: 13 }}>
            © {year} PePoll. Todos os direitos reservados.
          </Text>
          <Space size={16} wrap>
            <Link
              to="/faq"
              style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, textDecoration: 'none', borderBottom: '1px solid rgba(255,255,255,0.20)', paddingBottom: 1 }}
            >
              Perguntas Frequentes
            </Link>
            <Link
              to="/legal/termos-de-uso"
              style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, textDecoration: 'none', borderBottom: '1px solid rgba(255,255,255,0.20)', paddingBottom: 1 }}
            >
              Termos de Uso
            </Link>
            <Link
              to="/legal/politica-de-privacidade"
              style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, textDecoration: 'none', borderBottom: '1px solid rgba(255,255,255,0.20)', paddingBottom: 1 }}
            >
              Privacidade
            </Link>
            <Link
              to="/legal/politica-de-cookies"
              style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, textDecoration: 'none', borderBottom: '1px solid rgba(255,255,255,0.20)', paddingBottom: 1 }}
            >
              Cookies
            </Link>
          </Space>
          <Text style={{ color: 'rgba(255,255,255,0.40)', fontSize: 13 }}>
            Uma solução do{' '}
            <a
              href="https://vogals.co"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'rgba(255,255,255,0.75)',
                textDecoration: 'none',
                borderBottom: '1px solid rgba(255,255,255,0.25)',
                paddingBottom: 1,
              }}
            >
              Grupo Vogals
            </a>
          </Text>
        </div>
      </div>
    </footer>
  );
};
